import React, { Key, useCallback } from "react";

import { faAngleDown } from "@fortawesome/pro-solid-svg-icons/faAngleDown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Dropdown from "antd/es/dropdown";
import Menu from "antd/es/menu";
import { FormattedMessage, useIntl } from "react-intl";

import { EntityType, EntityTypeSupportingReports } from "@mapmycustomers/shared/types/entity";
import { Button } from "@mapmycustomers/ui";

import { getEntityTypeDisplayName } from "@app/util/ui";

import styles from "./EntityTypeMenu.module.scss";

const ALL = "all";

const supportedEntityTypes: Readonly<EntityTypeSupportingReports[]> = [
  EntityType.COMPANY,
  EntityType.PERSON,
  EntityType.DEAL,
  EntityType.ACTIVITY,
  EntityType.TRIP,
];

interface Props {
  onChange: (entityType: EntityTypeSupportingReports | undefined) => void;
  value?: EntityTypeSupportingReports;
}

const EntityTypeMenu: React.FC<Props> = ({ onChange, value }) => {
  const intl = useIntl();

  const handleMenuClick = useCallback(
    ({ key }: { key: Key }) =>
      onChange(key === ALL ? undefined : (key as EntityTypeSupportingReports)),
    [onChange]
  );

  return (
    <Dropdown
      overlay={
        <Menu className={styles.dropdown}>
          <Menu.Item key={ALL} onClick={handleMenuClick}>
            <FormattedMessage
              id="reports.exports.type.all"
              defaultMessage="All"
              description="Filter option to show all report types"
            />
          </Menu.Item>
          {supportedEntityTypes.map((entityType) => (
            <Menu.Item key={entityType} onClick={handleMenuClick}>
              {getEntityTypeDisplayName(intl, entityType, { lowercase: false, plural: true })}
            </Menu.Item>
          ))}
        </Menu>
      }
      trigger={["click"]}
    >
      <Button className={styles.recordTypeButton} type="link">
        {value
          ? getEntityTypeDisplayName(intl, value, { lowercase: false, plural: true })
          : intl.formatMessage({
              id: "reports.exports.allType",
              defaultMessage: "All Record Types",
              description: "Title for all record types option for exports",
            })}
        <FontAwesomeIcon icon={faAngleDown} />
      </Button>
    </Dropdown>
  );
};

export default EntityTypeMenu;
